import axios from 'axios';

export default function sendRequest(options) {
  return axios.request(options);
}
